<dashboard-dialog-frame class="contact-request-dialog" [header]="headerName()" [actions]="actions()" [dialogRef]="dialogRef">
	@if(contactRequestDetails(); as details) {
	<div class="p-2 h-100">
		<div class="bg-light rounded shadow-sm h-100">
			<div class="pt-2 ps-1">
				<h5>
					<span class="badge bg-secondary-subtle text-black px-3 py-2">
						Status : {{details.closed ? 'Closed' : 'Open'}}
					</span>
				</h5>
			</div>

			<div class="p-3 pt-0">
				<table class="table table-borderless mb-4">
					<tbody>
						<tr>
							<th [width]="200">Contacted Person:</th>
							<td>
								<span role="button" type="button" class="text-decoration-underline"
									(click)="openPersonDialog(details.person.id)">
									{{details.person.fullName}}
								</span>
							</td>
						</tr>
						<tr>
							<th [width]="200">Created Date:</th>
							<td>{{details.requestedDateUTC}}</td>
						</tr>
					</tbody>
				</table>

				<table class="table table-borderless mb-4">
					<tbody>
						<tr>
							<th [width]="200">Category:</th>
							<td>{{details.categoryName}}</td>
						</tr>
						<tr>
							<th [width]="200">Response Requested:</th>
							<td>{{details.responseRequested ? 'Yes' : 'No'}}</td>
						</tr>
					</tbody>
				</table>

				<table class="table table-borderless mb-4">
					<tbody>
						<tr>
							<th [width]="200">Details:</th>
							<td>{{details.details}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
	}
</dashboard-dialog-frame>